export const commonErrorMessage: Record<number, string> = {
  400: "Error en solicitud",
  401: "Tu sesión ha expirado, ingresa de nuevo",
  403: "No tienes permisos para esta acción",
  500: "Error en el servidor monitoreo, vuelve a intentarlo más tarde",
};

export const apiErrorCategory: Record<string, string> = {
  SYS: "Sistema (errores generales)",
  FIL: "Manejo de archivos",
  INI: "Iniciativas",
  ICO: "Contactos de iniciativas",
  ILO: "Localizaciones de iniciativas",
  IUS: "Usuarios de iniciativas",
  IJI: "Invitaciones a unirse a una iniciativa",
  IJR: "Solicitudes para unirse a una iniciativa",
  RES: "Recursos",
  RTY: "Tipos de recursos",
  RFI: "Archivos de recursos",
  RLI: "Enlaces de recursos",
  LOC: "Localizaciones",
  TAG: "Etiquetas",
  STO: "Historias del territorio",
  SVI: "Videos de historias del territorio",
  USR: "Usuarios",
  IND: "Indicadores",
};

export const apiErrorMsg: Record<string, string> = {
  SYS_001: "Los datos de la entidad no pueden ser nulos",
  SYS_002: "La propiedad es obligatoria",
  SYS_003: "Valor de propiedad inválido",
  SYS_004: "No encontrado",
  SYS_005: "Elemento deshabilitado",
  SYS_006: "Elemento duplicado",
  SYS_007: "Error de base de datos",
  SYS_008: "Filtro inválido",
  SYS_009: "Límite de filas excedido",
  SYS_010: "Longitud de texto inválida",
  FIL_001: "El archivo está vacío",
  FIL_002: "Formato de archivo inválido",
  FIL_003: "Error al procesar el archivo",
  FIL_004: "Error de almacenamiento",
  FIL_005: "Tamaño de archivo inválido",
  INI_001: "Iniciativa no encontrada",
  INI_002: "Se requiere al menos una ubicación",
  INI_003: "Se requiere al menos un contacto",
  INI_004: "Se requiere al menos un usuario",
  INI_005: "Ya existe una iniciativa con el mismo nombre",
  INI_006: "Uno o más usuarios son inválidos o no existen",
  INI_007: "Datos de ubicación de la iniciativa inválidos",
  INI_008: "Ubicaciones de la iniciativa inválidas (datos duplicados)",
  INI_009: "El número de líderes por iniciativa debe estar entre 1 y 3",
  INI_010: "Objeto JSON inválido",
  INI_011: "El tipo de GeoJSON debe ser 'Polygon'",
  INI_012: "Tipo de imagen inválido",
  INI_013: "Iniciativa deshabilitada",
  INI_014: "Ubicación del polígono inválida",
  ICO_001: "Ya existe un contacto con el mismo correo electrónico y/o teléfono",
  ILO_001: "La ubicación ya pertenece a la iniciativa",
  ILO_002: "La localidad solo está disponible para municipios",
  ILO_003: "Se requiere al menos una ubicación por iniciativa",
  IUS_001: "El usuario ya pertenece a la iniciativa",
  IUS_002: "Se requiere al menos un líder por iniciativa",
  IUS_003: "Límite de líderes por iniciativa excedido",
  IJI_001: "Se requiere al menos un invitado",
  IJI_002: "Hay correos electrónicos duplicados",
  IJI_003:
    "Uno o más usuarios con los correos ingresados ya están en la iniciativa",
  IJI_004: "Fallo al enviar los correos electrónicos",
  IJI_005:
    "Uno o más usuarios con los correos ingresados ya tienen una invitación",
  IJR_001: "El nivel de usuario debe ser 'Miembro' o 'Lector'",
  IJR_002: "Hay una o más solicitudes de unión pendientes",
  IJR_003: "La solicitud de unión ya ha sido revisada",
  IJR_004: "El usuario no pertenece a la iniciativa",
  RES_001: "Recurso no encontrado",
  RES_002: "Ya existe un recurso con el mismo nombre",
  RTY_001: "Tipo de recurso no encontrado",
  RFI_001: "Límite de elementos por recurso excedido",
  RLI_001: "Límite de elementos por recurso excedido",
  RLI_002: "Ya existe un enlace con la misma URL",
  RLI_003: "URL no encontrada",
  LOC_001: "Ubicación no encontrada",
  TAG_001: "Etiqueta no encontrada",
  TAG_002: "Etiqueta duplicada",
  TAG_003: "La etiqueta tiene relaciones con una o más entidades",
  STO_001: "Historia de territorio no encontrada",
  STO_002: "Historia de territorio deshabilitada",
  STO_003:
    "Formato inválido. Las palabras clave deben estar separadas por comas. No se permiten espacios ni caracteres especiales. Solo se permiten hasta 5 palabras clave.",
  STO_004: "Ya existe una historia de territorio con el mismo título",
  STO_005: "Ya existe al menos un video con la misma URL",
  SVI_001: "Ya existe un video con la misma URL",
  SVI_002: "La URL del video no existe",
  USR_001: "El usuario es inválido o no existe",
  IND_001: "El indicador especificado no existe",
  IND_002: "Solo se requiere un indicador",
  IND_003: "Grupo superior no encontrado",
  IND_004: "El grupo y la descripción son obligatorios",
  IND_005: "Se requiere el intervalo de confianza",
  IND_006: "Intervalo de confianza inválido",
  IND_007: "Tipo de indicador inválido",
  IND_008: "Unidad de medida inválida",
  IND_009: "Ubicación no encontrada",
  IND_010: "Se requiere fecha final",
  IND_011: "No se requiere fecha final",
  IND_012: "Rango de fechas inválido",
  IND_013: "Categoría no encontrada",
  IND_014:
    "El indicador actual no tiene los datos geográficos suministrados en la hoja de cálculo",
};
